import { atom } from "recoil";

import {
  IDataChangedModalPayload,
  IDialog,
  ISoftValidationModalPayload,
} from "../../models";

export const dialogsAtom = atom<IDialog[]>({
  key: "modalsAtom",
  default: [],
});

export const dataChangedConfirmRideAtom = atom<IDataChangedModalPayload | null>(
  {
    key: "dataChangedConfirmRideAtom",
    default: null,
  },
);

export const softValidationErrorAtom = atom<ISoftValidationModalPayload | null>(
  {
    key: "softValidationErrorAtom",
    default: null,
  },
);
